import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
//import { pushRoute } from '../../utils'
import { deleteTitolareUser } from '../../state/actions/stepActions'
import Collapse, { Panel } from 'rc-collapse'
import 'rc-collapse/assets/index.css'
import Button from '../../components/button'
import Clearfix from '../../components/clearfix'
import { connect } from 'react-redux'
//import Title from '../../components/title'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'
import Widgets from '../../components/widgets'
import { updateAllWidgets } from '../../state/actions/widgetsActions'
import { updateAllComponents} from '../../state/actions/componentsActions'
import { getTipDocValues } from '../../state/static/titolareStatic'
class TitolareEffictivo extends Component {
  constructor(props) {
    super(props)
    this.state = { accordion: true, activeKey: '0'}
    this.onChange = this.onChange.bind(this)
  
  }
 
  onChange(activeKey) {
    const { dispatch } = this.props
    if (activeKey) {
      const { titolareList} = this.props
      titolareList.map(o => {
        o.isUpdated = false
        if(!!o.type)
        {
        delete o.type
        }
        o.open = parseInt(activeKey) === o.id
        if (o.userComponents["DOCUMENTO-TIPO_DOCUMENTO"].values.length === 0) {
          o.userComponents["DOCUMENTO-TIPO_DOCUMENTO"].values = getTipDocValues().Values
        }
      })
    }

    this.setState({ activeKey })
  }
  deleteTitolare(index) {
    const { dispatch } = this.props
    dispatch(deleteTitolareUser(index))
    this.setState({ activeKey:(index-1).toString() })
  }
  getItems() {  
    const { titolareList} = this.props
    if (!this.globalStylesOverrides) {
      this.globalStylesOverrides = css(this.props.styles.globals)
    }
    let ownerNome=""
    let ownerCogNome=""
    if (!!titolareList) {
      if (!titolareList.some(o => o.open)) {
        titolareList.map(o => {
          if (o.id === 0) {
            o.open = true
          }
        })
      }
      return titolareList.map(user => {
        if (user.open && !user.isUpdated) {
          if (
            user.userWidgets &&
            user.userComponents &&
            Object.keys(user.userComponents).length
          ) {
            const { dispatch } = this.props
            dispatch(updateAllWidgets(user.userWidgets))
            dispatch(updateAllComponents(user.userComponents))
            user.isUpdated = true
          }
        }
        if(!user.open ||  (!!user.userWidgets["TITOLARE_EFFETTIVO"] 
        && !!user.userWidgets["TITOLARE_EFFETTIVO"].status && 
        user.userWidgets["TITOLARE_EFFETTIVO"].status[0]==='ignoreValidation' && !!user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"] && user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"].value==='' && !!user.userComponents["TITOLARE_DATA-EFFETTIVO_NO"] && user.userComponents["TITOLARE_DATA-EFFETTIVO_NO"].value===''))
        {
          user.userWidgets['SZ0025'].status=['hidden']
          user.userWidgets['TITOLARE_OWNER'].status=['hidden']
        }
        else
        {
          user.userWidgets['SZ0025'].status=['']
          user.userWidgets['TITOLARE_OWNER'].status=['']
        }
        if(!!user.userWidgets["TITOLARE_EFFETTIVO"] 
        && !!user.userWidgets["TITOLARE_EFFETTIVO"].status && 
        user.userWidgets["TITOLARE_EFFETTIVO"].status[0]!=='ignoreValidation' && !!user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"] && 
        user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"].value==='' && 
        !!user.userComponents["TITOLARE_DATA-EFFETTIVO_NO"] && 
        user.userComponents["TITOLARE_DATA-EFFETTIVO_NO"].value==='')
        {
          user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"].value='selected';
         }
        if (user.id === 0 && !!user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"] && user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"].value === "selected") {
           ownerNome=titolareList[user.id].NOME
           ownerCogNome=titolareList[user.id].COGNOME
        }
        return (
          <Panel
            {...css(this.props.styles.detail)}
            showArrow={true}
            header={
              (ownerNome!=="" && ownerCogNome!=="" && user.id===0)?(
                `Titolare Effettivo` +
                ' : ' +ownerNome+' ' +ownerCogNome
              ):(
              `Titolare Effettivo` +
              ' : ' +
              user.userComponents['NOME_COGNOME-NOME'].value +
              ' ' +
              user.userComponents['NOME_COGNOME-COGNOME'].value)
            }
            key={user.id}
          >
            <Widgets
              widgets={user.userWidgets}
              components={user.userComponents}
            />
            {user.id === 0 ? null : (
              <Button
                text="Elimina titolare"
                type="primary"
                value={'Elimina titolare'}
                type="delete"
                action={this.deleteTitolare.bind(
                  this,
                  titolareList.indexOf(user)
                )}
              />
            )}
            <Clearfix />
          </Panel>
        )
      })
    } else {
      return null
    }
  }

  render() {
    const accordion = this.state.accordion
    let activeKey =this.state.activeKey 
    const { titolareList,dispatch} = this.props
    var comp=titolareList.find(o=>o.type==="add")
    if(!!comp)
    {
      activeKey=comp.id.toString()
      this.onChange(activeKey)
    }
    return (
      <Collapse
        accordion={accordion}
        onChange={this.onChange}
        activeKey={activeKey}
      >
        {this.getItems()}
      </Collapse>
    )
  }
}
TitolareEffictivo.propTypes = {
  titolareList: PropTypes.array.isRequired,
  widgets: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired
}

const mapStateToProps = state => {
  return { ...state }
}

export default connect(mapStateToProps)(withStyles(Styles)(TitolareEffictivo))



// WEBPACK FOOTER //
// ./components/titolareEffictivo/index.js